import {
    FETCH_LOAN_ORDER_BEGIN,
    FETCH_LOAN_ORDER_ERROR,
    FETCH_LOAN_ORDER_LIST_BEGIN,
    FETCH_LOAN_ORDER_LIST_ERROR,
    FETCH_LOAN_ORDER_LIST_SUCCESS,
    FETCH_LOAN_ORDER_SUCCESS,
    UPDATE_LOAN_ORDER_BEGIN,
    UPDATE_LOAN_ORDER_ERROR,
    UPDATE_LOAN_ORDER_SUCCESS
} from "../actions/loan/loanOrderActions";
import {
    FETCH_LOAN_ORDER_STATUSES_BEGIN,
    FETCH_LOAN_ORDER_STATUSES_ERROR,
    FETCH_LOAN_ORDER_STATUSES_SUCCESS
} from "../actions/loan/loanOrderStatusActions";
import {
    FETCH_LOAN_BANKS_BEGIN,
    FETCH_LOAN_BANKS_ERROR,
    FETCH_LOAN_BANKS_SUCCESS
} from "../actions/loan/loanBankActions";

const defaultLoanOrders = {
    loanOrderList: [],
    pagination: {},
    loading: false,
    error: null
};

const defaultLoanOrder = {
    loanOrder: null,
    loading: false,
    error: null
}

const defaultLoanOrderStatuses = {
    loanOrderStatuses: [],
    loading: false,
    error: null
};

const defaultLoanBanks = {
    loanBanks: [],
    loading: false,
    error: null
}

export const loanOrderList = (state = defaultLoanOrders, action) => {
    switch (action.type) {
        case FETCH_LOAN_ORDER_LIST_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_LOAN_ORDER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                loanOrderList: action.payload.loanOrderList,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_LOAN_ORDER_LIST_ERROR:
            return {
                ...state,
                loading: false,
                loanOrderList: [],
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const loanOrder = (state = defaultLoanOrder, action) => {
        switch (action.type) {
            case FETCH_LOAN_ORDER_BEGIN:
            case UPDATE_LOAN_ORDER_BEGIN:
                return {
                    ...state,
                    loading: true,
                    error: null
                };
            case UPDATE_LOAN_ORDER_SUCCESS:
            case FETCH_LOAN_ORDER_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    loanOrder: action.loanOrder,
                };
            case UPDATE_LOAN_ORDER_ERROR:
                return {
                    ...state,
                    loading: false,
                    error: action.error,
                };
            case FETCH_LOAN_ORDER_ERROR:
                return {
                    ...state,
                    loading: false,
                    loanOrder: null,
                    error: action.error,
                };
            default:
                return state;
        }
    }
;

export const loanOrderStatuses = (state = defaultLoanOrderStatuses, action) => {
    switch (action.type) {
        case FETCH_LOAN_ORDER_STATUSES_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_LOAN_ORDER_STATUSES_SUCCESS:
            return {
                ...state,
                loading: false,
                loanOrderStatuses: action.loanOrderStatuses,
            };
        case FETCH_LOAN_ORDER_STATUSES_ERROR:
            return {
                ...state,
                loading: false,
                loanOrderStatuses: [],
                error: action.error,
            };
        default:
            return state;
    }
};

export const loanBanks = (state = defaultLoanBanks, action) => {
    switch (action.type) {
        case FETCH_LOAN_BANKS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_LOAN_BANKS_SUCCESS:
            return {
                ...state,
                loading: false,
                loanBanks: action.payload.loanBanks,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_LOAN_BANKS_ERROR:
            return {
                ...state,
                loading: false,
                loanBanks: [],
                error: action.payload.error,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/loan.js